import { Notification } from "../../models";

export interface NotificationListResult {
  notifications: Notification[];
  notificationCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
